import 'client-only';

import { type Brand } from '@/consts/brands';
import { post } from '@/utils/http/client';
import { urls } from '@/utils/urls';

const processUpsellDecision = async ({
  brand,
  upsell,
  accepted,
}: {
  brand: Brand;
  upsell: string;
  accepted: boolean;
}): Promise<{
  error?: boolean;
  message?: string;
  title?: string;
}> => {
  try {
    const response = await post(urls[brand].api.upsells.process, {
      upsell,
      accepted,
    });

    return {
      message: response.data?.notification?.message ?? null,
      title: response.data?.notification?.title ?? null,
    };
  } catch (exception: any) {
    return {
      error: true,
    };
  }
};

export const UpsellService = {
  processUpsellDecision,
};
